import { BuildInAppToolId } from '../types/appTools';

const AppToolbarRenderByDefault = {
    [BuildInAppToolId.Messages]: false,
    [BuildInAppToolId.Meetings]: false,
};

export const getRenderByDefault = appToolId => AppToolbarRenderByDefault[appToolId] ?? true;
